export default "__VITE_ASSET__BJtPLzrr__"